import imgCapabilities from "../../imagens/cardsHomePage/cardCapabilities.png"
import imgContactUs from "../../imagens/cardsHomePage/imgContactUs.png"
import imgCertificates from "../../imagens/cardsHomePage/imgCertificates.png"
import imgCertificatesEn from "../../imagens/cardsHomePage/imgCertificatesEn.png"
import imgCapabilitiesEn from "../../imagens/cardsHomePage/imgCapabilitiesEn.png"
import imgMeioAmbiente from "../../imagens/cardsHomePage/imgMeioAmbiente.png"
import imgMeioAmbienteEn from "../../imagens/cardsHomePage/imgMeioAmbienteEn.png"
import imgContactUsEn from "../../imagens/cardsHomePage/imgContactUsEn.png"
import { useTranslation } from 'react-i18next';
import "./cards.css"
import { Link } from "react-router-dom"


const cardsData = [
    {
        link: "/Capabilities",
        imgPt: imgCapabilities,
        imgEn: imgCapabilitiesEn,
        altKey: 'menu.capabilities'
    },
    {
        link: "/Sustainability",
        imgPt: imgMeioAmbiente,
        imgEn: imgMeioAmbienteEn,
        altKey: 'menu.meioAmbiente'
    },
    {
        link: "/ContactUs",
        imgPt: imgContactUs,
        imgEn: imgContactUsEn,
        altKey: 'menu.contact_us'
    },
    {
        link: "/Certificates",
        imgPt: imgCertificates,
        imgEn: imgCertificatesEn,
        altKey: 'menu.certificates'
    }
];

function Card() {
    const { t, i18n } = useTranslation();

    const isPt = (i18n.language || '').startsWith('pt');

    return (
        <div className="container-fluid pt-3">
            <div className="d-flex flex-wrap justify-content-around mb-3">
                {cardsData.map((card, index) => {
                    const imgSrc = isPt ? card.imgPt : card.imgEn || card.imgPt;
                    const caption = t(card.translationKey);
                    const altText = t(card.altKey);
                    return (
                        <div key={index} className="d-flex flex-column justify-content-center align-items-center mb-2 mx-2">
                            <Link to={card.link}>
                                <img src={imgSrc} className="rounded img-fluid custom-img" alt={altText} />
                            </Link>
                            <p className="card-caption m-0 mt-2">{caption}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default Card